import Image from "./ImageUploadThing";

export default Image;